function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BDEDF8;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#66CEEF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M590.6,245.17c1.23-0.7,2.63-1.4,3.86-1.93c2.8-1.4,5.61-2.81,8.24-4.21c35.06-17.88,70.13-33.49,100.81-41.9 c4.21-1.23,8.41-2.45,12.45-3.33c0.53-0.18,0.88-0.18,1.4-0.35c7.01-1.58,13.5-2.81,19.46-3.33l-43.3-25.07 c-34.36-7.36-118.16,26.82-203.54,74.33l53.82,31.03C558.86,262,574.82,253.23,590.6,245.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M259.25,401.9c1.93-2.81,3.86-5.61,6.14-8.59C263.11,396.29,261,399.1,259.25,401.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M265.56,392.61c2.45-3.16,5.08-6.31,7.89-9.47C270.82,386.47,268.19,389.63,265.56,392.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M274.33,382.44c2.98-3.33,6.31-6.84,9.64-10.17C280.64,375.43,277.48,378.94,274.33,382.44z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.76,413.3c-2.45,5.43-3.86,10.52-4.03,15.43c0-0.35,0-0.53,0.18-0.7 C249.96,423.64,251.19,418.73,252.76,413.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M481.73,234.65l2.81,1.58c87.66-49.09,174.97-84.85,210.91-76.26l51.37,29.63c6.14,0.18,11.4,1.23,15.78,2.98 c-0.18,0-0.18-0.18-0.18-0.35l-64.34-37.17c-0.35-0.35-0.88-0.53-1.4-0.53c-39.45-9.47-131.31,29.45-220.02,79.77 C478.4,233.77,480.15,233.77,481.73,234.65z"
}), React.createElement("polygon", {
  className: "st1",
  points: "248.56,429.25 248.56,429.6 248.56,429.78 248.56,429.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M346.91,318.63c1.75-1.4,3.51-2.63,5.26-3.86C350.41,316.17,348.66,317.4,346.91,318.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M330.6,331.07c-15.25,11.92-31.56,25.95-45.58,39.97c13.85-13.85,30.86-28.4,49.79-43.3 C333.23,328.97,331.66,330.02,330.6,331.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M254.34,409.97c0.88-1.75,1.93-3.51,2.98-5.43C256.27,406.64,255.39,408.39,254.34,409.97z"
}), React.createElement("path", {
  className: "st1",
  d: "M594.28,243.07c-1.23,0.7-2.63,1.4-3.86,1.93C591.65,244.47,593.05,243.94,594.28,243.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M717.35,193.63c-0.53,0.18-0.88,0.18-1.4,0.35C716.47,193.63,716.82,193.63,717.35,193.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M703.5,196.96c-30.5,8.42-65.74,23.84-100.81,41.9C638.63,220.98,673.87,205.72,703.5,196.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M693.51,165.05l43.3,25.07c3.51-0.35,7.01-0.53,10.17-0.35l-51.37-29.63 c-35.94-8.59-123.25,27.17-210.91,76.26l5.43,3.16C575.17,191.87,659.15,157.86,693.51,165.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M673.17,723.26c-2.98,3.86-5.96,7.54-9.29,11.4C667.21,730.79,670.37,727.11,673.17,723.26z"
}), React.createElement("path", {
  className: "st1",
  d: "M654.24,746.05c-4.21,4.91-8.59,9.82-13.15,14.73C645.65,756.04,650.03,750.78,654.24,746.05z"
}), React.createElement("path", {
  className: "st1",
  d: "M711.04,669.08c-2.8,4.56-5.61,9.29-8.77,13.85C705.43,678.2,708.23,673.64,711.04,669.08z"
}), React.createElement("path", {
  className: "st1",
  d: "M726.47,640.86c-3.16,6.49-6.66,12.97-10.34,19.46C719.81,653.83,723.14,647.34,726.47,640.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.89,851.06c0.35-0.18,0.7-0.35,1.05-0.53c10.87-9.29,20.86-18.23,30.68-27.17 c-9.82,8.94-19.99,17.88-30.68,27C546.77,850.54,546.42,850.89,545.89,851.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M765.21,193.98c-0.88-0.53-1.93-0.7-2.8-1.05c2.1,1.4,2.98,4.03,2.1,6.31c-0.18,0.35-0.53,0.35-0.7,0.7 c4.21,3.16,6.49,7.71,6.31,14.38c-2.45,79.59-0.88,146.21-2.8,205.82c0.88,0,1.75,0.18,2.45,0.7c1.58,1.05,2.8,2.81,2.63,4.73 c-2.8,79.94-12.8,146.04-44.53,211.43c45.06-92.39,45.41-183.03,45.93-305.58c0.18-36.64,0.18-74.68,1.58-116.94 C775.91,202.92,770.3,196.96,765.21,193.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M630.74,772.17c-5.43,5.61-11.04,11.4-16.83,17.18C619.52,783.39,625.31,777.78,630.74,772.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.28,850.89c-1.05-0.7-1.58-1.75-1.93-2.98c-75.39,21.91-124.82,22.79-157.43,5.96c0,0.18,0,0.35-0.18,0.53 c-1.05,1.58-2.81,2.45-4.56,2.45c-0.35,0-0.88-0.18-1.23-0.35c16.48,9.47,36.47,14.38,61.54,14.38c29.45,0,65.04-6.49,108.35-19.46 l0.18-0.18c-0.53,0.18-1.23,0.35-1.93,0.35C542.38,851.59,541.33,851.24,540.28,850.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M607.25,795.49c-8.24,8.06-16.83,16.13-25.77,24.37C590.6,811.79,599.36,803.55,607.25,795.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M692.63,697.13c-2.1,3.16-4.38,6.31-6.66,9.47C688.25,703.44,690.35,700.11,692.63,697.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.34,190.47l-0.7-0.35c-5.96,0.53-12.45,1.75-19.46,3.33C724.19,191.87,731.02,190.82,737.34,190.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M602.69,239.03c-2.8,1.4-5.61,2.81-8.24,4.21C597.08,241.84,600.06,240.26,602.69,239.03z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.79,270.77c15.08-8.59,30.86-17.18,46.63-25.42C574.82,253.23,558.86,262,543.79,270.77L543.79,270.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M715.77,193.63c-4.03,0.88-8.24,2.1-12.45,3.33C707.71,195.91,712.09,194.68,715.77,193.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M746.98,189.77l12.8,7.36c1.75,0.7,3.16,1.75,4.38,2.81c0.18-0.35,0.53-0.35,0.7-0.7 c0.88-2.45,0-4.91-2.1-6.31C758.2,190.82,752.94,189.77,746.98,189.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M704.55,202.39c-33.14,9.29-71.18,26.82-105.01,44.18C638.81,226.41,675.27,210.98,704.55,202.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.34,190.47c-6.31,0.53-12.97,1.58-19.99,2.98c-0.53,0.18-0.88,0.18-1.4,0.35 c-4.03,0.88-8.24,2.1-12.45,3.33c-29.45,8.59-64.87,23.84-100.81,41.9c-2.8,1.4-5.61,2.81-8.24,4.21c-1.23,0.7-2.63,1.4-3.86,1.93 c-15.95,8.42-31.56,17.01-46.63,25.42l2.63,1.58c0.88,0.53,1.58,1.23,1.93,2.1c17.36-9.82,34.54-19.11,51.37-27.7 c33.66-17.36,71.88-34.89,105.01-44.18c24.37-7.19,43.83-9.47,54.87-5.08l-12.8-7.36c-3.16,0-6.49,0-10.17,0.35L737.34,190.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,842.3c-76.79,22.62-127.81,23.49-160.06,3.51c0.53,0.35,0.88,0.88,1.58,1.23 c2.1,1.58,2.63,4.38,1.4,6.84c32.43,16.83,81.87,15.95,157.43-5.96c-0.18-0.53-0.35-0.88-0.35-1.4 C538.18,846.5,538.18,842.3,538.18,842.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.76,260.95c52.59-27.88,99.23-47.69,132.19-55.93C674.75,214.49,622.33,240.09,583.76,260.95z"
}), React.createElement("path", {
  className: "st1",
  d: "M758.37,202.39c-0.35,0-0.7,0-1.05-0.18c0.88,0.35,1.75,0.53,2.45,0.88c2.28,1.4,5.08,4.03,4.91,10.87 c-1.23,42.43-1.4,80.47-1.58,117.29c-0.18,32.26-0.18,62.41-1.23,90.81l2.45-1.4c0.88-0.53,1.93-0.7,2.98-0.7 c1.93-59.61,0.35-126.23,2.8-205.82c0.18-6.66-2.1-11.22-6.31-14.38C762.76,201.87,760.65,202.92,758.37,202.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M340.07,793.21c-5.61-16.83-9.29-36.64-11.57-59.08C330.6,754.81,333.93,774.97,340.07,793.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M327.27,718.87c0.18,1.93,0.35,3.68,0.53,5.43C327.45,722.73,327.27,720.98,327.27,718.87L327.27,718.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M759.6,197.31c-14.38-3.51-33.66-0.88-55.05,5.08c-29.28,8.59-65.92,24.19-105.01,44.18 c-19.28,9.99-36.99,19.64-51.37,27.7c0.53,0.88,0.7,1.75,0.7,2.63v3.16c11.75-6.66,23.32-13.15,34.54-19.11 c38.75-20.86,90.99-46.46,132.19-55.93c19.11-4.91,33.31-5.79,41.55-2.63c0.35,0,0.7,0,1.05,0.18c2.28,0.53,4.38-0.7,5.61-2.63 C762.58,198.71,761.53,198.01,759.6,197.31L759.6,197.31z"
}), React.createElement("path", {
  className: "st1",
  d: "M704.55,202.39c21.39-5.96,40.67-8.59,55.05-5.08l0,0C748.38,192.93,728.92,195.2,704.55,202.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.52,274.1c14.38-8.06,32.08-17.88,51.37-27.7C582.88,254.99,565.53,264.28,548.52,274.1L548.52,274.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.87,834.41c2.28-1.93,4.56-4.03,6.84-5.96c5.08-4.38,9.82-8.77,14.73-13.15 c6.66-6.14,13.15-12.1,19.46-18.06c3.16-2.98,6.31-6.14,9.47-9.12c4.91-4.73,9.64-9.47,14.2-14.2c0.53-0.53,1.05-1.05,1.58-1.58 c51.72-53.12,85.38-100.98,107.12-148.84c0.35-0.88,0.7-1.75,1.23-2.45c2.63-5.96,5.08-11.92,7.36-17.71 c1.4-3.68,2.8-7.19,4.03-10.87c1.05-3.16,2.1-6.31,3.16-9.47c1.58-4.73,2.98-9.64,4.38-14.38c0.53-1.58,1.05-3.33,1.4-4.91 c1.93-7.01,3.51-14.03,5.08-21.21c0.35-1.4,0.53-2.63,0.88-4.03c1.58-7.54,2.98-15.08,4.21-22.97c0-0.35,0.18-0.7,0.18-1.05 c2.45-16.3,4.38-32.96,5.61-50.32c0-0.88,0.18-1.75,0.18-2.81c0.53-8.59,1.05-17.18,1.58-25.95c0-0.18,0-0.18,0-0.35L548.87,557.75 V834.41z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.87,834.58c2.45-2.1,4.56-4.03,6.84-6.14C553.43,830.55,551.15,832.48,548.87,834.58L548.87,834.58z"
}), React.createElement("path", {
  className: "st0",
  d: "M589.9,797.41c-6.31,5.96-12.8,11.92-19.46,18.06C577.27,809.34,583.76,803.2,589.9,797.41z"
}), React.createElement("path", {
  className: "st0",
  d: "M613.56,773.92c-4.56,4.73-9.29,9.47-14.2,14.2C604.1,783.39,609.01,778.83,613.56,773.92z"
}), React.createElement("path", {
  className: "st0",
  d: "M750.13,538.3c-0.35,1.4-0.53,2.63-0.88,4.03C749.43,541.1,749.61,539.7,750.13,538.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M738.21,582.83c-1.05,3.16-2.1,6.31-3.16,9.47C736.29,589.31,737.16,586.16,738.21,582.83z"
}), React.createElement("path", {
  className: "st0",
  d: "M744,563.37c-0.53,1.75-1.05,3.33-1.4,4.91C742.95,566.7,743.65,565.3,744,563.37z"
}), React.createElement("path", {
  className: "st0",
  d: "M754.52,514.28c0,0.35-0.18,0.7-0.18,1.05C754.17,514.98,754.17,514.81,754.52,514.28z"
}), React.createElement("path", {
  className: "st0",
  d: "M760.3,461.33c0,0.88-0.18,1.75-0.18,2.81C760.13,463.09,760.13,462.04,760.3,461.33z"
}), React.createElement("path", {
  className: "st0",
  d: "M722.26,623.5c-21.91,47.69-55.4,95.72-107.12,148.84C666.51,719.75,700.34,671.89,722.26,623.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M730.85,603.34c-2.28,5.96-4.73,11.92-7.36,17.71C726.29,615.26,728.57,609.13,730.85,603.34z"
}), React.createElement("path", {
  className: "st0",
  d: "M761.53,435.04L761.53,435.04c0,0.18,0,0.18,0,0.35C761.53,435.21,761.53,435.04,761.53,435.04z"
}), React.createElement("path", {
  className: "st1",
  d: "M664.05,734.83c-3.16,3.68-6.31,7.54-9.64,11.4C657.57,742.19,660.72,738.51,664.05,734.83z"
}), React.createElement("path", {
  className: "st1",
  d: "M702.27,682.76c-3.16,4.73-6.31,9.47-9.64,14.2C695.96,692.4,699.12,687.67,702.27,682.76z"
}), React.createElement("path", {
  className: "st1",
  d: "M545.54,851.24c0.18,0,0.35-0.18,0.53-0.35C545.72,851.24,545.72,851.24,545.54,851.24L545.54,851.24z"
}), React.createElement("path", {
  className: "st1",
  d: "M685.97,706.6c-4.03,5.61-8.24,11.04-12.8,16.66C677.55,717.65,681.76,712.21,685.97,706.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M613.74,789.17c-2.1,2.1-4.21,4.21-6.31,6.31C609.53,793.38,611.63,791.28,613.74,789.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M641.09,760.77c-3.33,3.68-7.01,7.54-10.52,11.22C634.25,768.31,637.76,764.63,641.09,760.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M581.66,819.85c-1.23,1.05-2.45,2.28-3.86,3.51C579.2,822.13,580.43,820.91,581.66,819.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M715.95,660.32c-1.58,2.98-3.33,5.79-5.08,8.77C712.62,666.1,714.37,662.95,715.95,660.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M728.4,636.82c-0.7,1.23-1.23,2.63-1.75,3.86C727.17,639.63,727.69,638.4,728.4,636.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,563.89v278.23c0.88-0.35,1.75-0.53,2.63-0.7c0.88-0.7,1.75-1.58,2.63-2.28l0.18-278.4L538.18,563.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.87,551.45l213.01-122.9c0-2.1,0.18-4.21,0.18-6.49L548.87,545.13L548.87,551.45L548.87,551.45z"
}), React.createElement("path", {
  className: "st1",
  d: "M770.3,420.84c-0.7-0.53-1.58-0.7-2.45-0.7c-0.88,30.15-2.8,58.56-6.49,85.73c-0.18,1.4-0.35,2.81-0.53,4.21 c-1.05,7.01-2.1,13.85-3.33,20.69c-0.18,1.23-0.53,2.45-0.7,3.86c-1.4,7.54-3.16,15.08-5.08,22.62c-0.35,1.75-0.88,3.33-1.4,5.08 c-1.58,5.96-3.33,11.92-5.08,17.71c-0.7,2.1-1.23,4.03-1.93,6.14c-2.45,7.19-4.91,14.38-7.71,21.56c-0.53,1.4-1.23,2.8-1.75,4.21 c-2.45,5.96-5.08,11.92-7.89,17.71c-1.05,2.28-2.1,4.56-3.33,7.01c-3.16,6.31-6.49,12.62-9.99,19.11 c-0.53,1.05-1.05,1.93-1.58,2.98c-4.03,7.01-8.41,14.2-13.15,21.39c-1.58,2.28-3.16,4.73-4.73,7.19 c-3.86,5.61-7.89,11.4-12.1,17.18c-1.4,1.93-2.8,3.86-4.21,5.79c-5.43,7.36-11.4,14.73-17.53,22.09c-1.93,2.28-3.86,4.56-5.79,6.84 c-4.91,5.79-10.17,11.75-15.6,17.71c-2.1,2.28-4.21,4.56-6.31,7.01c-7.36,7.71-14.9,15.6-22.97,23.67 c-1.75,1.75-3.68,3.51-5.43,5.26c-6.84,6.66-14.03,13.5-21.56,20.34c-2.63,2.45-5.43,4.91-8.06,7.36 c-9.47,8.59-19.11,17.18-29.63,26.12c-1.75,0.53-3.33,0.88-5.08,1.4c0.35,1.23,0.88,2.28,1.93,2.98c0.88,0.7,1.93,0.88,3.16,0.88 c0.7,0,1.23-0.18,1.93-0.35c0.18,0,0.35-0.18,0.53-0.35c0.35-0.18,0.7-0.35,1.05-0.7c10.69-9.12,20.86-18.23,30.68-27 c1.23-1.23,2.63-2.28,3.86-3.51c8.94-8.24,17.53-16.3,25.77-24.37c2.1-2.1,4.21-4.21,6.31-6.31c5.79-5.79,11.4-11.4,16.83-17.18 c3.51-3.68,7.19-7.54,10.52-11.22c4.56-4.91,8.94-9.82,13.15-14.73c3.33-3.86,6.49-7.54,9.64-11.4c3.16-3.86,6.14-7.71,9.29-11.4 c4.38-5.61,8.77-11.22,12.8-16.66c2.28-3.16,4.56-6.31,6.66-9.47c3.33-4.73,6.49-9.47,9.64-14.2c2.98-4.73,5.96-9.29,8.77-13.85 c1.75-2.98,3.51-5.79,5.08-8.77c3.68-6.49,7.19-12.97,10.34-19.46c0.7-1.23,1.23-2.63,1.75-3.86 c31.56-65.39,41.73-131.49,44.53-211.43C773.1,423.64,772.05,421.89,770.3,420.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.44,839.31c-0.88,0.7-1.75,1.58-2.63,2.28c-0.88,0.35-1.75,0.53-2.63,0.7v4.03c0,0.53,0.18,0.88,0.35,1.4 c1.75-0.53,3.33-0.88,5.08-1.4h-0.18L543.44,839.31L543.44,839.31z"
}), React.createElement("path", {
  className: "st1",
  d: "M692.81,686.96c-3.86,5.61-7.89,11.4-12.1,17.18C684.92,698.36,689.13,692.75,692.81,686.96z"
}), React.createElement("path", {
  className: "st1",
  d: "M631.1,763.58c-7.36,7.71-14.9,15.6-22.97,23.67C616.19,779.01,624.08,771.29,631.1,763.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M756.45,534.62c-1.4,7.54-3.16,15.08-5.08,22.62C753.47,549.69,754.87,542.15,756.45,534.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M676.68,709.93c-5.43,7.36-11.4,14.73-17.53,22.09C665.11,724.66,671.24,717.3,676.68,709.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.95,586.16c-2.45,7.19-4.91,14.38-7.71,21.56C738.21,600.36,740.67,593.17,742.95,586.16z"
}), React.createElement("path", {
  className: "st1",
  d: "M722.26,636.47c-3.16,6.31-6.49,12.62-9.99,19.11C715.95,649.27,719.1,642.96,722.26,636.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M750.13,562.14c-1.58,5.96-3.33,11.92-5.08,17.71C746.98,574.06,748.38,568.28,750.13,562.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M764.86,420.84l-2.45,1.4c0,2.1-0.18,4.21-0.18,6.49l5.43-3.16c-1.05,28.23-2.8,54.7-6.31,80.47 c3.68-27.17,5.61-55.58,6.49-85.73C766.79,419.78,765.74,420.31,764.86,420.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M653.18,738.86c-4.91,5.79-10.17,11.75-15.6,17.71C643.19,750.43,648.28,744.82,653.18,738.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M602.87,792.33c-6.84,6.66-14.03,13.5-21.56,20.34C588.67,806.01,596.03,798.99,602.87,792.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M733.48,611.75c-2.45,5.96-5.08,11.92-7.89,17.71C728.57,623.5,731.02,617.89,733.48,611.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M760.48,510.07c-1.05,7.01-2.1,13.85-3.33,20.69C758.37,523.75,759.43,517.08,760.48,510.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.86,658.56c-4.03,7.01-8.41,14.2-13.15,21.39C702.27,672.76,706.66,665.75,710.86,658.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M573.07,820.21c-9.47,8.59-19.11,17.18-29.63,26.12C554.13,837.39,563.95,828.62,573.07,820.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M599.36,788.12c-2.98,2.98-6.31,5.96-9.47,9.12C593.05,794.26,596.21,791.1,599.36,788.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M723.49,621.22c-0.35,0.88-0.7,1.75-1.23,2.45C722.79,622.62,723.14,622.1,723.49,621.22z"
}), React.createElement("path", {
  className: "st1",
  d: "M760.13,463.79c-1.23,17.36-3.16,34.19-5.61,50.32C756.97,497.8,758.55,481.14,760.13,463.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M615.32,772.34c-0.53,0.53-1.05,1.05-1.58,1.58C614.26,773.57,614.62,773.05,615.32,772.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.53,435.21c-0.35,8.77-0.88,17.53-1.58,25.95C760.65,452.74,761.36,443.98,761.53,435.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M749.26,542.33c-1.58,7.19-3.16,14.2-5.08,21.21C746.1,556.53,747.5,549.34,749.26,542.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.06,592.47c-1.23,3.68-2.63,7.19-4.03,10.87C732.25,599.66,733.83,595.98,735.06,592.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.87,554.43c0,1.93-0.88,3.68-2.63,4.73l-2.8,1.58l-0.18,278.4c1.93-1.58,3.68-3.16,5.43-4.73V557.58 l212.66-122.72c0.18-2.1,0.18-4.21,0.18-6.31l-213.01,122.9L548.87,554.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M742.77,568.63c-1.4,4.91-2.8,9.64-4.38,14.38C739.62,578.27,741.37,573.18,742.77,568.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.17,515.33c-1.23,7.71-2.63,15.43-4.21,22.97C751.71,530.93,752.94,523.04,754.17,515.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M570.44,815.3c-4.73,4.38-9.64,8.77-14.73,13.15C560.97,823.89,565.53,819.68,570.44,815.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M725.59,629.64c-1.05,2.28-2.1,4.56-3.33,7.01C723.49,634.37,724.54,631.92,725.59,629.64z"
}), React.createElement("path", {
  className: "st1",
  d: "M608.13,787.07c-1.75,1.75-3.68,3.51-5.43,5.26C604.8,790.75,606.55,788.82,608.13,787.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M581.48,812.84c-2.63,2.45-5.43,4.91-8.06,7.36C576.05,817.58,578.5,815.12,581.48,812.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M697.72,680.13c-1.58,2.28-3.16,4.73-4.73,7.19C694.56,684.69,695.96,682.41,697.72,680.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.23,607.72c-0.53,1.4-1.23,2.8-1.75,4.21C734.18,610.35,734.88,609.13,735.23,607.72z"
}), React.createElement("path", {
  className: "st1",
  d: "M712.27,655.41c-0.53,1.05-1.05,1.93-1.58,2.98C711.21,657.51,711.92,656.46,712.27,655.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M745.05,579.85c-0.7,2.1-1.23,4.03-1.93,6.14C743.82,583.88,744.35,581.95,745.05,579.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M680.71,704.32c-1.4,1.93-2.8,3.86-4.21,5.79C678.08,708,679.31,706.25,680.71,704.32z"
}), React.createElement("path", {
  className: "st1",
  d: "M659.15,732.02c-1.93,2.28-3.86,4.56-5.79,6.84C655.29,736.58,657.22,734.3,659.15,732.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M757.15,530.58c-0.18,1.23-0.53,2.45-0.7,3.86C756.8,533.39,756.97,531.81,757.15,530.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.18,505.86c-0.18,1.4-0.35,2.81-0.53,4.21C760.65,508.67,760.83,507.09,761.18,505.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M637.76,756.39c-2.1,2.28-4.21,4.56-6.31,7.01C633.37,761.3,635.48,759.02,637.76,756.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M751.54,557.23c-0.35,1.75-0.88,3.33-1.4,5.08C750.49,560.56,751.01,558.81,751.54,557.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M761.88,428.55c0,2.1-0.18,4.21-0.18,6.31l0,0c0,0.18,0,0.18,0,0.35c-0.35,8.77-0.88,17.53-1.58,25.95 c0,0.88-0.18,1.75-0.18,2.81c-1.23,17.18-3.16,34.01-5.61,50.32c0,0.35-0.18,0.7-0.18,1.05c-1.23,7.71-2.63,15.25-4.21,22.97 c-0.35,1.4-0.53,2.63-0.88,4.03c-1.58,7.01-3.16,14.2-5.08,21.21c-0.53,1.75-1.05,3.33-1.4,4.91c-1.4,4.91-2.8,9.64-4.38,14.38 c-1.05,3.16-2.1,6.31-3.16,9.47c-1.23,3.68-2.63,7.19-4.03,10.87c-2.28,5.96-4.73,11.92-7.36,17.71c-0.35,0.88-0.7,1.75-1.23,2.45 c-21.91,48.39-55.75,96.25-107.12,148.84c-0.53,0.53-1.05,1.05-1.58,1.58c-4.56,4.73-9.29,9.47-14.2,14.2 c-2.98,2.98-6.31,5.96-9.47,9.12c-6.31,5.96-12.8,11.92-19.46,18.06c-4.73,4.38-9.64,8.77-14.73,13.15 c-2.28,2.1-4.38,4.03-6.84,6.14v-0.18c-1.75,1.58-3.68,3.16-5.43,4.73v7.19h0.18c10.34-8.94,20.16-17.53,29.63-26.12 c2.8-2.45,5.43-4.91,8.06-7.36c7.54-6.84,14.73-13.68,21.56-20.34c1.75-1.75,3.68-3.51,5.43-5.26c8.06-8.06,15.6-15.78,22.97-23.67 c2.1-2.28,4.21-4.56,6.31-7.01c5.43-5.96,10.69-11.92,15.6-17.71c1.93-2.28,3.86-4.56,5.79-6.84c6.14-7.36,12.1-14.73,17.53-22.09 c1.4-1.93,2.8-3.86,4.21-5.79c4.21-5.79,8.24-11.4,12.1-17.18c1.58-2.45,3.16-4.73,4.73-7.19c4.56-7.19,9.12-14.38,13.15-21.39 c0.53-1.05,1.05-1.93,1.58-2.98c3.51-6.31,6.84-12.62,9.99-19.11c1.23-2.28,2.28-4.56,3.33-7.01c2.8-5.96,5.43-11.92,7.89-17.71 c0.53-1.4,1.23-2.8,1.75-4.21c2.8-7.19,5.43-14.38,7.71-21.56c0.7-2.1,1.23-4.03,1.93-6.14c1.75-5.96,3.51-11.75,5.08-17.71 c0.53-1.75,0.88-3.33,1.4-5.08c1.93-7.54,3.51-15.08,5.08-22.62c0.18-1.23,0.53-2.45,0.7-3.86c1.23-6.84,2.45-13.68,3.33-20.69 c0.18-1.4,0.35-2.81,0.53-4.21c3.51-25.6,5.26-52.24,6.31-80.47L761.88,428.55z"
}), React.createElement("path", {
  className: "st0",
  d: "M343.05,435.21c-1.58,2.1-3.33,4.03-4.73,6.14c-6.31,8.77-11.04,17.53-14.38,25.95v0.18l2.81,205.82 l211.61-122.02l0.18-265.08c-8.59,5.08-18.41,10.87-29.45,17.71C432.64,351.24,372.68,399.45,343.05,435.21z"
}), React.createElement("path", {
  className: "st0",
  d: "M323.94,467.47L323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st0",
  d: "M509.08,303.9c-0.18,0.18-0.35,0.18-0.53,0.35c-72.23,44.71-129.73,89.94-160.77,125 c-1.75,1.93-3.16,4.03-4.73,5.96C372.68,399.45,432.64,351.24,509.08,303.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.79,283.04l-0.18,265.25l5.26-3.16l0.18-265.25c-0.18,0.18-0.35,0.18-0.7,0.35 c-0.7,0.35-1.4,0.88-2.1,1.23C545.72,282.16,544.49,282.51,543.79,283.04z"
}), React.createElement("polygon", {
  className: "st1",
  points: "326.75,679.6 326.75,685.91 538.18,563.89 538.18,557.58  "
}), React.createElement("path", {
  className: "st1",
  d: "M549.05,280.06L549.05,280.06c-0.18,0.18-0.35,0.18-0.7,0.35C548.7,280.23,548.87,280.23,549.05,280.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.42,281.63c0.7-0.35,1.4-0.88,2.1-1.23c-0.53,0.35-1.23,0.7-1.93,1.05l0,0 C546.59,281.63,546.42,281.63,546.42,281.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.52,280.23c0.18-0.18,0.35-0.18,0.7-0.35v-3.16c0,1.93-1.05,3.68-2.45,4.56 C547.12,281.11,547.82,280.76,548.52,280.23z"
}), React.createElement("polygon", {
  className: "st1",
  points: "543.61,554.43 538.18,557.58 538.18,563.89 543.61,560.91 543.61,554.43 548.87,551.45 548.87,545.31  543.61,548.11  "
}), React.createElement("path", {
  className: "st1",
  d: "M543.61,560.91l2.8-1.58c1.58-1.05,2.63-2.8,2.63-4.73v-2.98l-5.26,3.16L543.61,560.91z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,554.43c0-1.93,1.05-3.68,2.63-4.73l2.8-1.58l0.18-265.25c-1.75,1.05-3.51,2.1-5.43,3.16l-0.18,265.08 L326.57,673.11v6.31L538,557.41L538.18,554.43L538.18,554.43z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.55,304.25c-50.67,31.03-121.67,78.37-160.77,125C378.82,394.19,436.32,349.13,508.55,304.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,554.43v2.98l5.43-3.16v-6.14l-2.8,1.58C539.23,550.92,538.18,552.5,538.18,554.43z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.35,458.7c4.73-11.92,13.67-25.07,26.47-39.27c0.35-0.53,0.88-1.05,1.4-1.58 c1.58-1.75,3.16-3.51,4.73-5.26c2.63-2.81,5.26-5.61,8.06-8.42c1.75-1.75,3.51-3.51,5.26-5.08c2.98-2.81,5.79-5.61,8.94-8.42 c1.75-1.75,3.68-3.33,5.61-4.91c3.16-2.81,6.31-5.61,9.64-8.42c1.93-1.58,3.86-3.16,5.79-4.91c3.33-2.81,6.84-5.61,10.17-8.24 c1.93-1.58,3.86-2.98,5.96-4.56c3.51-2.81,7.19-5.43,10.87-8.24c1.93-1.4,3.86-2.81,5.79-4.21c3.86-2.81,7.54-5.43,11.4-8.06 c1.75-1.23,3.68-2.63,5.43-3.86c3.86-2.81,7.71-5.43,11.57-8.06c1.75-1.05,3.33-2.28,4.91-3.33c4.03-2.63,7.89-5.26,11.92-7.89 c1.4-1.05,2.98-1.93,4.38-2.81c4.03-2.63,8.06-5.08,11.92-7.71c1.23-0.88,2.63-1.58,3.86-2.45c2.81-1.75,5.43-3.33,8.06-5.08 c1.23-0.7,2.45-1.58,3.68-2.28c1.05-0.7,2.1-1.23,3.16-1.93c0.53-0.35,1.23-0.7,1.75-1.05c1.93-1.23,3.86-2.45,5.96-3.68 c4.03-2.45,8.06-4.91,12.27-7.36c1.4-0.88,2.8-1.75,4.21-2.63c1.4-0.88,2.8-1.58,4.21-2.45l-54-31.21 c-15.43,8.77-30.86,17.88-45.93,27.35c-1.05,0.7-2.1,1.23-2.98,1.93c-7.71,4.91-15.43,9.82-22.97,14.73 c-0.35,0.18-0.53,0.35-0.88,0.53c-15.78,10.34-30.86,21.04-45.23,31.56c-1.23,0.88-2.45,1.93-3.86,2.81 c-6.66,4.91-12.97,9.82-19.11,14.55c-0.7,0.53-1.58,1.23-2.28,1.75c-4.73,3.68-9.12,7.36-13.32,10.87 c-2.1,1.75-4.21,3.51-6.14,5.26c-2.63,2.28-5.26,4.56-7.71,6.84c-1.93,1.75-3.68,3.33-5.61,5.08c-2.45,2.28-4.91,4.56-7.19,6.84 c-1.4,1.4-2.98,2.81-4.21,4.21c-2.63,2.63-5.08,5.26-7.36,7.89c-0.88,0.88-1.75,1.75-2.45,2.63c-6.14,7.01-11.05,13.32-14.73,19.11 c-0.53,0.88-1.05,1.93-1.58,2.81c-0.88,1.58-1.75,3.16-2.45,4.73c-0.88,3.16-1.93,6.49-2.63,9.64L315.35,458.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M478.92,245.69c-15.78,8.94-31.03,18.23-45.93,27.35C448.24,263.75,463.67,254.46,478.92,245.69L478.92,245.69 z"
}), React.createElement("path", {
  className: "st2",
  d: "M370.22,390.86c1.75-1.75,3.68-3.33,5.61-4.91C374.08,387.53,372.33,389.1,370.22,390.86z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.96,409.62c3.68-5.79,8.59-12.27,14.73-19.11C275.38,397.34,270.3,404.01,266.96,409.62z"
}), React.createElement("path", {
  className: "st2",
  d: "M343.23,417.86c1.58-1.75,3.16-3.51,4.73-5.26C346.56,414.52,344.8,416.1,343.23,417.86z"
}), React.createElement("path", {
  className: "st2",
  d: "M356.2,404.36c1.75-1.75,3.51-3.51,5.26-5.08C359.71,400.85,357.95,402.43,356.2,404.36z"
}), React.createElement("path", {
  className: "st2",
  d: "M504.69,293.91c-1.05,0.7-2.1,1.23-3.16,1.93c0.18,0,0.18-0.18,0.35-0.18 C502.76,294.96,503.82,294.43,504.69,293.91z"
}), React.createElement("path", {
  className: "st2",
  d: "M338.14,338.96c6.14-4.91,12.62-9.64,19.11-14.55C350.41,329.5,343.93,334.4,338.14,338.96z"
}), React.createElement("path", {
  className: "st2",
  d: "M308.51,364.03c2.45-2.28,5.08-4.56,7.71-6.84C313.6,359.48,310.97,361.75,308.51,364.03z"
}), React.createElement("path", {
  className: "st2",
  d: "M322.36,351.94c4.21-3.51,8.77-7.19,13.32-10.87C331.13,344.75,326.75,348.25,322.36,351.94z"
}), React.createElement("path", {
  className: "st2",
  d: "M360.76,321.78c14.38-10.52,29.45-21.04,45.23-31.56C390.21,300.92,374.96,311.44,360.76,321.78z"
}), React.createElement("path", {
  className: "st2",
  d: "M295.54,375.96c2.28-2.28,4.73-4.56,7.19-6.84C300.45,371.22,297.82,373.68,295.54,375.96z"
}), React.createElement("path", {
  className: "st2",
  d: "M406.87,289.87c7.54-4.91,15.25-9.82,22.97-14.73C422.12,279.71,414.4,284.97,406.87,289.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M283.97,388.05c2.28-2.63,4.73-5.08,7.36-7.89C288.88,382.62,286.25,385.42,283.97,388.05z"
}), React.createElement("path", {
  className: "st2",
  d: "M435.44,339.31c1.75-1.23,3.68-2.63,5.43-3.86C439.12,336.51,437.37,337.74,435.44,339.31z"
}), React.createElement("path", {
  className: "st2",
  d: "M452.62,327.22c1.75-1.05,3.33-2.28,4.91-3.33C455.95,325.11,454.38,326.17,452.62,327.22z"
}), React.createElement("path", {
  className: "st2",
  d: "M263.11,416.63c0,0.18-0.18,0.35-0.18,0.7c0.7-1.58,1.58-3.16,2.45-4.73 C264.33,413.82,263.63,415.4,263.11,416.63z"
}), React.createElement("path", {
  className: "st2",
  d: "M469.63,316.17c1.4-0.88,2.98-1.93,4.38-2.81C472.43,314.07,470.86,315.3,469.63,316.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M485.76,305.48c1.23-0.88,2.63-1.58,3.86-2.45C488.39,303.9,487.16,304.78,485.76,305.48z"
}), React.createElement("path", {
  className: "st2",
  d: "M418.44,351.41c1.93-1.4,3.86-2.81,5.79-4.21C422.12,348.61,420.54,350.18,418.44,351.41z"
}), React.createElement("path", {
  className: "st2",
  d: "M401.78,364.38c1.93-1.58,3.86-2.98,5.96-4.56C405.64,361.23,403.53,362.81,401.78,364.38z"
}), React.createElement("path", {
  className: "st2",
  d: "M385.48,377.18c1.93-1.58,3.86-3.16,5.79-4.91C389.69,374.03,387.58,375.6,385.48,377.18z"
}), React.createElement("path", {
  className: "st2",
  d: "M512.06,289.35c-1.93,1.23-3.86,2.45-5.96,3.68c1.05-0.7,2.1-1.4,3.33-1.93 C510.3,290.4,511.35,289.87,512.06,289.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M532.92,276.9c-1.4,0.88-2.8,1.58-4.21,2.45c-1.4,0.88-2.8,1.75-4.21,2.63 C527.13,280.23,530.29,278.48,532.92,276.9L532.92,276.9z"
}), React.createElement("path", {
  className: "st2",
  d: "M332.18,431.53c1.23-1.58,2.63-3.16,3.86-4.73c1.93-2.45,3.68-4.91,5.79-7.19 c-12.8,14.2-21.91,27.52-26.47,39.27l0,0C319.03,450.46,324.47,441.17,332.18,431.53z"
}), React.createElement("path", {
  className: "st2",
  d: "M512.06,289.35c4.03-2.45,8.06-4.91,12.27-7.36C520.47,284.44,516.26,286.72,512.06,289.35z"
}), React.createElement("path", {
  className: "st2",
  d: "M501.54,296.01c-1.23,0.7-2.45,1.58-3.68,2.28C498.91,297.24,500.31,296.54,501.54,296.01L501.54,296.01z"
}), React.createElement("path", {
  className: "st2",
  d: "M332.18,431.53c0.53-0.7,1.05-1.4,1.58-2.1c0.7-0.88,1.4-1.75,2.28-2.81 C334.99,428.2,333.41,429.78,332.18,431.53z"
}), React.createElement("path", {
  className: "st2",
  d: "M501.71,295.49c-0.18,0-0.18,0.18-0.35,0.18h-0.18C501.54,296.01,501.54,295.66,501.71,295.49z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.7,458.7L315.7,458.7c2.1-4.38,4.56-8.94,7.36-13.5c0.88-1.4,1.93-2.81,2.81-4.21 c2.1-3.16,4.03-6.31,6.49-9.47c0,0,0-0.18,0.18-0.18C324.47,441.17,319.03,450.46,315.7,458.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M515.91,287.25c0.88-0.53,1.58-1.05,2.45-1.58c3.86-2.28,7.36-4.38,10.87-6.49c0.53-0.35,1.05-0.7,1.58-0.88 c0.7-0.35,1.58-0.88,2.28-1.4l0,0c-2.8,1.75-5.79,3.33-8.59,5.08c-4.03,2.45-8.24,4.91-12.27,7.36c-0.88,0.53-1.75,1.05-2.63,1.58 C511.88,289.52,513.81,288.3,515.91,287.25z"
}), React.createElement("path", {
  className: "st2",
  d: "M325.69,441.17c-0.88,1.4-1.93,2.81-2.81,4.21C323.59,443.98,324.64,442.4,325.69,441.17z"
}), React.createElement("path", {
  className: "st2",
  d: "M530.64,278.13c-0.53,0.35-1.05,0.7-1.58,0.88C529.59,279.01,530.29,278.48,530.64,278.13z"
}), React.createElement("path", {
  className: "st2",
  d: "M332.18,431.88c0.53-0.7,1.23-1.4,1.75-2.28c-0.53,0.7-1.05,1.4-1.58,2.1 C332.18,431.53,332.18,431.53,332.18,431.88z"
}), React.createElement("path", {
  className: "st2",
  d: "M518.37,285.67c-0.88,0.53-1.58,1.05-2.45,1.58C516.79,286.72,517.49,286.19,518.37,285.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M257.32,404.53c0.53-0.88,1.05-1.75,1.75-2.63C258.37,402.95,257.85,403.83,257.32,404.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.29,234.65c-41.9,23.84-86.08,51.89-124.12,80.12c35.94-26.47,79.94-54.87,124.65-80.12 C476.47,234.65,476.29,234.65,476.29,234.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M334.81,327.92c3.86-2.98,7.89-6.14,12.1-9.29C342.7,321.78,338.67,324.94,334.81,327.92z"
}), React.createElement("path", {
  className: "st1",
  d: "M248.56,429.25L248.56,429.25c0-0.18,0-0.35,0-0.53C248.56,429.08,248.56,429.25,248.56,429.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.63,383.14c0.18-0.18,0.35-0.53,0.7-0.7C274.15,382.62,273.8,382.79,273.63,383.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.76,412.77c0,0.18-0.18,0.53-0.18,0.7c0.53-1.05,1.05-2.28,1.58-3.33 C253.99,411.02,253.29,411.72,252.76,412.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M265.04,393.49c0.18-0.18,0.35-0.35,0.53-0.7C265.56,392.96,265.39,393.14,265.04,393.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M283.97,372.27c0.35-0.35,0.53-0.53,0.88-0.88C284.67,371.57,284.14,371.75,283.97,372.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.35,273.57c0.88-0.53,1.75-1.05,2.63-1.58c0.35-0.18,0.7-0.35,1.05-0.7c0.53-0.35,1.05-0.53,1.58-0.88 l-53.82-31.03c-1.93,1.05-3.68,1.93-5.61,2.98l32.96,18.93L538.35,273.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M251.19,424.87c1.05-0.7,2.28-0.7,3.51-0.53c0.7-3.16,1.58-6.49,3.33-10.17l0,0c0.53-1.23,1.58-2.63,2.28-4.03 c0.88-1.58,1.58-2.98,2.63-4.56c0.53-0.7,1.05-1.4,1.58-2.28c7.36-10.87,18.23-23.14,32.08-36.12c0.7-0.7,1.23-1.23,1.93-1.93 c2.98-2.81,6.14-5.61,9.47-8.42c1.05-0.88,1.93-1.75,2.98-2.63c2.98-2.63,6.14-5.08,9.29-7.71c1.4-1.23,2.81-2.45,4.38-3.68 c2.63-2.28,5.61-4.38,8.42-6.66c2.1-1.58,4.03-3.33,6.31-4.91c2.28-1.75,4.73-3.68,7.19-5.43c2.81-2.1,5.61-4.21,8.59-6.49 c1.75-1.4,3.68-2.63,5.61-4.03c3.68-2.63,7.19-5.26,11.05-7.89c1.23-0.88,2.45-1.75,3.68-2.63c4.56-3.16,8.94-6.31,13.67-9.47 c0.53-0.35,1.05-0.7,1.4-1.05c28.05-19.11,58.38-37.87,88.71-55.05l0,0c1.75-1.05,3.68-2.1,5.43-3.16l-2.81-1.58 c-1.58-0.88-3.33-0.88-4.91-0.18c-44.71,25.42-88.71,53.65-124.65,80.12c-1.75,1.23-3.51,2.63-5.26,3.86 c-4.21,3.16-8.24,6.14-12.1,9.29c-18.93,14.73-35.94,29.45-49.79,43.3c-0.35,0.35-0.53,0.53-0.88,0.88 c-3.51,3.51-6.66,6.84-9.64,10.17c-0.18,0.18-0.35,0.53-0.7,0.7c-2.81,3.33-5.61,6.49-7.89,9.47c-0.18,0.18-0.35,0.35-0.53,0.7 c-2.28,2.98-4.21,5.79-6.14,8.59c-0.53,0.88-1.05,1.75-1.75,2.63c-1.05,1.75-2.1,3.68-2.98,5.43c-0.53,1.05-1.23,2.28-1.58,3.33 c-1.58,5.26-2.81,10.17-3.86,14.55c-0.18,0.18,0,0.53-0.18,0.7c0,0.18,0,0.53,0,0.7c0,0,0,0,0,0.18 C248.56,427.5,249.61,425.92,251.19,424.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M258.2,414.35c-1.75,3.51-2.81,6.84-3.33,10.17c0.18,0,0.35,0.18,0.53,0.18 C256.09,421.36,256.8,417.86,258.2,414.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M298.7,365.61c2.98-2.81,6.14-5.61,9.47-8.42C304.83,360,301.5,362.81,298.7,365.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M260.48,410.14c0.88-1.58,1.58-2.98,2.63-4.56C262.06,407.34,261.18,408.74,260.48,410.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M310.97,354.57c2.98-2.63,6.14-5.08,9.29-7.71C316.93,349.13,313.77,351.94,310.97,354.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.28,307.58c1.23-0.88,2.45-1.75,3.68-2.63C373.91,305.83,372.68,306.53,371.28,307.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M354.8,319.5c1.75-1.4,3.68-2.63,5.61-4.03C358.48,316.87,356.55,318.1,354.8,319.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M388.63,295.49c0.53-0.35,1.05-0.7,1.4-1.05C389.86,294.96,389.16,294.96,388.63,295.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M339.37,331.25c2.28-1.75,4.73-3.68,7.19-5.43C343.93,327.74,341.65,329.5,339.37,331.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.47,343.17c2.63-2.28,5.61-4.38,8.42-6.66C330.08,338.61,327.27,340.89,324.47,343.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M489.97,239.56l-5.43-3.16c-1.75,1.05-3.68,2.1-5.43,3.16l5.43,3.16 C486.28,241.66,488.04,240.61,489.97,239.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M296.59,367.36c-13.85,12.97-24.72,25.07-32.08,36.12C271.87,392.43,282.92,380.34,296.59,367.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.38,271.47c-0.35,0.18-0.7,0.35-1.05,0.7c0,0,0,0,0.18,0C541.51,271.99,542.03,271.82,542.38,271.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M542.38,271.47c0.53-0.35,1.05-0.53,1.58-0.88l0,0C543.26,270.77,542.74,271.29,542.38,271.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M541.33,271.99c1.58-0.88,3.51-0.88,5.26,0l-2.63-1.58c-0.53,0.35-1.05,0.53-1.58,0.88 C542.03,271.82,541.51,271.99,541.33,271.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.05,435.21L343.05,435.21c-1.58,2.1-3.33,4.03-4.73,6.14C339.54,439.42,341.47,437.32,343.05,435.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.78,303.55c-0.18,0.18-0.53,0.35-0.7,0.53c11.04-6.66,20.86-12.62,29.45-17.71l0,0 C530.11,291.1,520.47,297.06,509.78,303.55z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.05,435.21c-10.17,12.27-16.66,23.14-19.11,32.08c3.33-8.59,8.06-17.18,14.38-25.95 C339.54,439.42,341.47,437.32,343.05,435.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,286.19L538.18,286.19c-0.7,0.35-1.23,0.7-1.75,1.05c-3.33,1.93-6.49,3.86-9.82,5.79 c-5.08,2.98-9.99,5.96-14.9,9.12c-0.53,0.35-0.88,0.53-1.4,0.88c-0.18,0.18-0.53,0.35-0.7,0.53 C520.47,297.06,530.11,291.1,538.18,286.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.08,303.9c0.18-0.18,0.53-0.35,0.7-0.53l-0.18,0.18c-0.35,0.18-0.7,0.35-1.05,0.7 C508.55,304.25,508.72,303.9,509.08,303.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.05,435.21c1.58-1.93,2.98-4.03,4.73-5.96l0,0C346.03,431.35,344.45,433.46,343.05,435.21L343.05,435.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47c2.45-8.94,9.12-19.81,19.11-32.08c1.58-1.93,2.98-4.03,4.73-5.96 C334.81,443.98,326.4,457.13,323.94,467.47L323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,286.19c-0.7,0.35-1.23,0.7-1.75,1.05C536.95,286.89,537.83,286.72,538.18,286.19L538.18,286.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.88,302.15c4.91-2.98,9.99-5.96,14.9-9.12C521.52,296.01,516.79,299.17,511.88,302.15z"
}), React.createElement("path", {
  className: "st1",
  d: "M510.3,303.02c-0.35,0.18-0.7,0.35-1.05,0.53l0.18-0.18C509.78,303.2,510.3,303.2,510.3,303.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M541.16,271.99c-0.88,0.53-1.75,1.05-2.63,1.58l0,0C539.23,273.04,540.11,272.52,541.16,271.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.35,273.57c0.88-0.53,1.75-1.05,2.8-1.58c0,0,0,0-0.18,0C540.11,272.52,539.23,273.04,538.35,273.57 L538.35,273.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.42,281.63c-0.88,0.53-1.75,1.05-2.45,1.4l0,0C544.49,282.51,545.72,282.16,546.42,281.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M342,427.67c33.66-39.1,97.83-87.48,166.55-129.91c-1.58,0.88-2.98,1.75-4.56,2.81 C451.75,332.83,380.92,380.34,342,427.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M503.82,300.57c-52.24,32.08-123.07,79.77-161.82,127.1l0,0C380.92,380.34,451.75,332.83,503.82,300.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M541.33,271.99c-0.88,0.53-1.93,1.05-2.8,1.58l5.26,3.16c1.58-0.88,3.16-1.75,4.73-2.63 c-0.53-0.88-1.23-1.58-1.93-2.1C544.66,271.29,542.74,271.29,541.33,271.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M546.42,281.63l0.18-0.18l0,0C546.59,281.28,546.59,281.28,546.42,281.63c-0.7,0.35-1.75,1.05-2.45,1.4l0,0 C544.49,282.51,545.54,282.16,546.42,281.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.61,276.9L543.61,276.9v6.31c0.88-0.53,1.75-1.05,2.63-1.58c0,0,0.18,0,0.18-0.18 c1.4-1.05,2.45-2.81,2.45-4.56c0-0.88-0.35-1.93-0.7-2.63C546.77,275.15,545.37,275.85,543.61,276.9L543.61,276.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M342,427.67c-0.18,0.18-0.18,0.18-0.35,0.35c34.89-40.67,102.91-91.34,174.79-135.17 c-2.63,1.58-5.26,3.16-7.89,4.91C440,340.37,375.66,388.58,342,427.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.65,428.02c0.18-0.18,0.18-0.18,0.35-0.35l0,0C342,428.02,342,428.02,341.65,428.02L341.65,428.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.61,276.9L543.61,276.9L543.61,276.9c1.58-0.88,3.16-1.75,4.73-2.63l0,0 C546.77,275.15,545.37,275.85,543.61,276.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.18,286.19c1.93-1.05,3.68-2.28,5.43-3.16l0,0c-0.18,0-0.18,0.18-0.35,0.18 C541.68,284.09,540.11,285.14,538.18,286.19L538.18,286.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M534.32,288.47c-2.63,1.58-4.91,2.98-7.54,4.56c3.33-1.93,6.49-3.86,9.82-5.79 C535.72,287.77,534.85,288.3,534.32,288.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M510.3,303.02c0.53-0.35,0.88-0.53,1.4-0.88C511.35,302.5,510.83,302.67,510.3,303.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.44,283.39c-1.75,1.05-3.51,1.93-5.08,2.98l0,0C540.11,285.14,541.68,284.09,543.44,283.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.79,283.04L543.79,283.04c-0.18,0-0.18,0.18-0.35,0.18C543.44,283.04,543.61,283.04,543.79,283.04z"
}), React.createElement("path", {
  className: "st1",
  d: "M508.55,304.25c0.35-0.18,0.7-0.35,1.05-0.7c-50.67,31.03-122.37,78.54-161.64,125.7l0,0 C386.88,382.62,457.71,335.46,508.55,304.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.65,428.02c-2.28,2.98-4.56,5.79-6.66,8.77c-0.53,0.7-1.23,1.58-1.75,2.28c-1.23,1.75-2.28,3.51-3.33,5.26 c-3.68,5.79-6.84,11.57-9.29,17.18l0.53,0.35c1.75,1.05,2.63,2.63,2.81,4.56v0.88c2.81-10.52,11.05-23.49,24.02-38.22 c39.27-46.98,110.97-94.67,161.64-125.7c0.35-0.18,0.7-0.35,1.05-0.53c0.53-0.35,0.88-0.53,1.4-0.88c4.91-2.98,9.99-5.96,14.9-9.12 c2.45-1.58,4.91-2.98,7.54-4.56c0.7-0.53,1.58-0.88,2.28-1.4c0.7-0.35,1.23-0.7,1.75-1.05l0,0c1.75-1.05,3.51-1.93,5.08-2.98 c0.18,0,0.18-0.18,0.35-0.18v-6.31c-7.71,4.56-17.01,9.99-27.35,16.3C444.56,336.68,376.71,387.53,341.65,428.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M333.23,439.07c-1.23,1.75-2.28,3.51-3.33,5.26C331.13,442.75,331.83,440.82,333.23,439.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M334.99,436.79c2.1-2.98,4.38-5.79,6.66-8.77l0,0C339.37,431.18,337.27,433.98,334.99,436.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M497.68,298.29c-2.63,1.58-5.43,3.33-8.06,5.08c2.28-1.4,4.56-2.81,6.84-4.38 C497.15,298.82,497.33,298.29,497.68,298.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M391.44,372.62c3.33-2.81,6.84-5.61,10.17-8.24C398.45,366.84,394.77,369.82,391.44,372.62z"
}), React.createElement("path", {
  className: "st1",
  d: "M407.74,359.65c3.51-2.81,7.19-5.43,10.87-8.24C414.93,354.04,411.07,356.85,407.74,359.65z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.01,385.77c3.16-2.81,6.31-5.61,9.64-8.42C382.5,379.99,379.34,382.79,376.01,385.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M424.22,347.38c3.68-2.81,7.54-5.43,11.4-8.06C431.59,341.94,428.08,344.4,424.22,347.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M457.71,324.06c4.03-2.63,8.06-5.26,11.92-7.89C465.42,318.63,461.56,321.26,457.71,324.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M440.88,335.46c3.86-2.63,7.71-5.43,11.57-8.06C448.77,330.02,444.73,332.65,440.88,335.46z"
}), React.createElement("path", {
  className: "st1",
  d: "M474.01,313.19c4.03-2.63,8.06-5.08,11.92-7.71C481.9,308.11,477.87,310.74,474.01,313.19z"
}), React.createElement("path", {
  className: "st1",
  d: "M505.57,293.38c0.18-0.18,0.35-0.35,0.7-0.35c-0.53,0.35-1.23,0.7-1.75,1.05 C504.87,293.91,505.22,293.73,505.57,293.38C505.39,293.38,505.57,293.38,505.57,293.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M361.46,399.1c2.98-2.81,5.79-5.61,8.94-8.42C367.24,393.49,364.44,396.29,361.46,399.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M302.73,368.94c1.75-1.75,3.68-3.33,5.61-5.08C306.59,365.61,304.83,367.19,302.73,368.94z"
}), React.createElement("path", {
  className: "st1",
  d: "M348.14,412.77c2.63-2.81,5.26-5.61,8.06-8.42C353.22,407.16,350.77,409.97,348.14,412.77z"
}), React.createElement("path", {
  className: "st1",
  d: "M316.23,357.02c2.1-1.75,4.03-3.51,6.14-5.26C320.08,353.51,318.16,355.27,316.23,357.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.33,379.99c1.4-1.4,2.81-2.81,4.21-4.21C294.31,377.18,292.74,378.76,291.33,379.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M281.34,390.68c0.7-0.88,1.58-1.75,2.45-2.63C283.09,388.75,282.39,389.8,281.34,390.68z"
}), React.createElement("path", {
  className: "st1",
  d: "M343.23,417.86c-0.53,0.53-0.88,1.05-1.4,1.58c0.18-0.35,0.53-0.53,0.88-0.88 C343.05,418.38,343.23,418.21,343.23,417.86z"
}), React.createElement("path", {
  className: "st1",
  d: "M429.83,274.8c1.05-0.7,2.1-1.23,2.98-1.93C431.94,273.57,430.88,274.27,429.83,274.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M406.16,290.4c0.35-0.18,0.53-0.35,0.88-0.53C406.69,290.05,406.34,290.05,406.16,290.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M357.08,324.59c1.23-0.88,2.45-1.93,3.86-2.81C359.53,322.83,358.48,323.54,357.08,324.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M337.27,339.84c-0.53,0.35-1.05,0.88-1.4,1.23c0.7-0.53,1.58-1.23,2.28-1.75 C337.62,339.31,337.62,339.49,337.27,339.84z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.3,274.27c0.35-0.18,0.7-0.35,1.05-0.7l-21.04-12.1l-32.96-18.93c-1.75,1.05-3.51,2.1-5.43,3.16l54,31.21 C534.5,275.85,535.72,275.15,537.3,274.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M265.39,412.6c0.53-0.88,0.88-1.75,1.58-2.81C266.09,410.67,265.91,411.72,265.39,412.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.35,458.7L315.35,458.7l-55.22-31.91c0.7-3.16,1.75-6.49,2.63-9.64c-1.58,3.33-2.81,6.49-3.16,9.29 l54.35,31.38L315.35,458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M263.11,405.58c0.53-0.7,1.05-1.4,1.58-2.28C264.16,404.01,263.28,405.06,263.11,405.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M346.38,325.99c2.81-2.1,5.61-4.21,8.59-6.49C351.99,321.78,349.19,323.89,346.38,325.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M296.59,367.36c0.7-0.7,1.23-1.23,1.93-1.93C297.82,366.14,297.12,366.66,296.59,367.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M360.58,315.3c3.68-2.63,7.19-5.26,11.05-7.89C367.77,310.21,363.91,312.67,360.58,315.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M375.13,304.78c4.56-3.16,8.94-6.31,13.67-9.47C384.25,298.64,379.52,301.62,375.13,304.78z"
}), React.createElement("path", {
  className: "st1",
  d: "M332.88,336.16c2.1-1.58,4.03-3.33,6.31-4.91C337.09,332.83,334.99,334.76,332.88,336.16z"
}), React.createElement("path", {
  className: "st1",
  d: "M258.2,414.35L258.2,414.35c0.53-1.23,1.58-2.63,2.28-4.03C259.43,411.72,258.72,413.12,258.2,414.35z"
}), React.createElement("path", {
  className: "st1",
  d: "M307.99,357.02c1.05-0.88,1.93-1.75,2.98-2.63C309.74,355.27,308.86,356.32,307.99,357.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,346.5c1.4-1.23,2.81-2.45,4.38-3.68C322.89,344.22,321.49,345.27,320.08,346.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M478.92,239.56c-30.33,17.18-60.66,35.94-88.71,55.05C418.26,275.32,448.42,256.56,478.92,239.56 L478.92,239.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M496.63,298.82c-2.28,1.4-4.56,2.81-6.84,4.38c-1.23,0.7-2.45,1.58-3.86,2.45c-3.86,2.45-7.89,5.08-11.92,7.71 c-1.4,0.88-2.98,1.93-4.38,2.81c-3.86,2.63-7.89,5.26-11.92,7.89c-1.58,1.05-3.33,2.28-4.91,3.33c-3.86,2.63-7.71,5.26-11.57,8.06 c-1.75,1.23-3.68,2.45-5.43,3.86c-3.86,2.63-7.54,5.43-11.4,8.06c-1.93,1.4-3.86,2.81-5.79,4.21c-3.68,2.63-7.19,5.43-10.87,8.24 c-1.93,1.58-4.03,2.98-5.96,4.56c-3.51,2.81-6.84,5.43-10.17,8.24c-1.93,1.58-3.86,3.16-5.79,4.91c-3.33,2.81-6.49,5.61-9.64,8.42 c-1.93,1.58-3.86,3.33-5.61,4.91c-2.98,2.81-5.96,5.61-8.94,8.42c-1.75,1.75-3.68,3.51-5.26,5.08c-2.81,2.81-5.43,5.61-8.06,8.42 c-1.58,1.75-3.33,3.51-4.73,5.26c-0.18,0.18-0.35,0.35-0.53,0.7C376.71,381.39,434.22,338.09,496.63,298.82z"
}), React.createElement("path", {
  className: "st1",
  d: "M505.39,293.38c-0.35,0.18-0.53,0.35-0.88,0.53c-0.88,0.53-1.75,1.05-2.63,1.75 C503.11,294.96,504.17,294.26,505.39,293.38z"
}), React.createElement("polygon", {
  className: "st1",
  points: "313.77,457.83 315.35,458.7 315.35,458.7  "
}), React.createElement("path", {
  className: "st1",
  d: "M256.62,424.87l2.81,1.75c0.53-2.81,1.58-5.96,3.16-9.29c0-0.18,0.18-0.35,0.18-0.7 c0.7-1.23,1.58-2.63,2.28-4.03c0.53-0.88,0.88-1.75,1.58-2.81c3.68-5.79,8.59-12.27,14.73-19.11c0.7-0.88,1.58-1.75,2.45-2.63 c2.28-2.63,4.73-5.08,7.36-7.89c1.4-1.4,2.81-2.81,4.21-4.21c2.28-2.28,4.73-4.56,7.19-6.84c1.75-1.75,3.68-3.33,5.61-5.08 c2.45-2.28,5.08-4.56,7.71-6.84c2.1-1.75,4.03-3.51,6.14-5.26c4.21-3.51,8.77-7.19,13.32-10.87c0.53-0.35,1.05-0.88,1.4-1.23 c0.18-0.18,0.53-0.35,0.88-0.53c6.14-4.73,12.45-9.64,19.11-14.55c1.23-0.88,2.45-1.93,3.86-2.81 c14.03-10.34,29.28-20.86,45.23-31.56c0.35-0.18,0.53-0.35,0.88-0.53c7.54-4.91,15.08-9.82,22.97-14.73 c1.05-0.7,2.1-1.23,2.98-1.93c14.73-9.29,30.15-18.41,45.93-27.35l0,0c1.75-1.05,3.51-2.1,5.43-3.16l-5.43-3.16 c-30.33,17.18-60.66,35.94-88.71,55.05c-0.53,0.35-1.05,0.7-1.4,1.05c-4.56,3.16-9.12,6.31-13.67,9.47 c-1.23,0.88-2.45,1.75-3.68,2.63c-3.68,2.63-7.36,5.26-11.05,7.89c-1.93,1.4-3.68,2.63-5.61,4.03c-2.98,2.1-5.61,4.21-8.59,6.49 c-2.45,1.75-4.91,3.68-7.19,5.43c-2.1,1.75-4.21,3.33-6.31,4.91c-2.81,2.28-5.79,4.56-8.42,6.66c-1.58,1.23-2.81,2.45-4.38,3.68 c-3.16,2.63-6.31,5.26-9.29,7.71c-1.05,0.88-1.93,1.75-2.98,2.63c-3.16,2.81-6.49,5.61-9.47,8.42c-0.7,0.7-1.23,1.23-1.93,1.93 c-13.85,12.97-24.72,25.07-32.08,36.12c-0.53,0.7-1.05,1.4-1.58,2.28c-1.05,1.58-1.75,3.16-2.63,4.56c-0.7,1.4-1.58,2.81-2.28,4.03 c-1.23,3.68-1.93,7.01-2.81,10.17C255.92,424.69,256.27,424.69,256.62,424.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.6,290.93c-1.05,0.7-2.1,1.4-3.33,1.93c-0.18,0.18-0.35,0.35-0.7,0.35 C506.97,292.33,508.2,291.63,509.6,290.93z"
}), React.createElement("path", {
  className: "st1",
  d: "M537.3,274.27c-1.4,0.88-2.98,1.75-4.38,2.63l0,0C534.5,276.2,535.72,275.15,537.3,274.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "505.39,293.38 505.57,293.38 505.57,293.38  "
}), React.createElement("path", {
  className: "st1",
  d: "M538.35,273.57L538.35,273.57c-0.35,0.18-0.7,0.35-1.05,0.7c0.35-0.18,0.53-0.35,0.88-0.53 C538.18,273.75,538.18,273.75,538.35,273.57z"
}), React.createElement("path", {
  className: "st1",
  d: "M501.54,296.01c-1.23,0.7-2.45,1.4-3.68,2.28c-0.35,0.18-0.7,0.53-1.23,0.7 C498.21,297.76,499.78,297.06,501.54,296.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M342.7,418.73c-0.35,0.35-0.53,0.53-0.88,0.88c-2.1,2.45-3.86,4.91-5.79,7.19 C338.32,424.17,340.42,421.36,342.7,418.73z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.7,458.7L315.7,458.7L315.7,458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M538,273.75l0.18-0.18l0,0C538.18,273.75,538.18,273.75,538,273.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.7,458.7L315.7,458.7L315.7,458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M501.71,295.49c-0.18,0.18-0.35,0.18-0.53,0.35c-1.58,0.88-3.16,1.93-4.73,2.98 c-62.24,39.1-119.92,82.4-153.75,119.74c-2.28,2.63-4.56,5.43-6.66,8.06c-0.7,0.88-1.58,1.75-2.28,2.81 c33.49-41.37,100.81-92.39,171.63-136.22c0,0-0.18,0-0.18,0.18C504.17,294.26,503.11,294.96,501.71,295.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.7,458.7v0.18V458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M505.57,293.38L505.57,293.38c3.51-2.1,6.84-4.21,10.17-6.14c-2.1,1.23-4.21,2.45-6.31,3.86 C508.2,291.63,506.97,292.33,505.57,293.38z"
}), React.createElement("path", {
  className: "st1",
  d: "M332.18,431.88c-2.28,3.16-4.38,6.31-6.49,9.47C327.8,438.02,329.9,435.04,332.18,431.88z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.24,279.01c-3.33,2.1-7.01,4.21-10.87,6.49C522.22,283.39,525.91,281.28,529.24,279.01z"
}), React.createElement("path", {
  className: "st1",
  d: "M532.92,276.9c-0.7,0.35-1.58,0.88-2.28,1.4c2.63-1.58,5.08-2.98,7.36-4.38c-0.35,0.18-0.53,0.35-0.88,0.53 C535.72,275.15,534.5,276.2,532.92,276.9L532.92,276.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.89,445.56c-2.81,4.56-5.08,9.12-7.19,13.5C317.63,454.32,320.08,449.94,322.89,445.56z"
}), React.createElement("path", {
  className: "st1",
  d: "M509.25,297.59c-1.75,1.05-3.51,2.1-5.26,3.16c1.58-1.05,2.98-1.93,4.56-2.81 C508.72,297.76,509.08,297.59,509.25,297.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M538,273.75c-2.45,1.4-4.73,2.81-7.36,4.38c-0.53,0.35-1.05,0.7-1.58,0.88c-3.33,2.1-7.01,4.21-10.87,6.49 c-0.88,0.53-1.58,1.05-2.45,1.58c-3.33,1.93-6.66,4.03-10.34,6.31c-70.83,43.83-138.15,94.85-171.63,136.22 c-0.53,0.7-1.23,1.4-1.75,2.28c-2.28,3.16-4.38,6.31-6.49,9.47c-0.88,1.4-1.93,2.81-2.81,4.21c-2.81,4.56-5.08,9.12-7.19,13.5 h-0.18l0,0l4.56,2.63c3.68-9.99,11.22-21.39,21.91-33.66c38.74-47.51,109.75-95.02,161.82-127.1c1.93-1.05,3.51-2.1,5.26-3.16 c11.4-7.01,22.97-14.03,34.54-20.69l-5.26-3.16C538.18,273.75,538.18,273.75,538,273.75z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.44,293.21c0.7-0.35,1.23-0.7,1.93-1.23c-2.98,1.75-6.14,3.68-9.12,5.61c-0.18,0.18-0.53,0.35-0.7,0.53 C511.35,296.19,513.81,294.43,516.44,293.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.79,276.9L543.79,276.9c-4.21,2.45-9.12,5.26-14.03,8.24C534.5,282.34,539.05,279.53,543.79,276.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.37,291.8c3.68-2.28,7.54-4.56,11.22-6.84c5.08-2.98,9.82-5.79,14.03-8.42l0,0 c-11.57,6.66-23.14,13.67-34.54,20.69C512.41,295.49,515.39,293.73,518.37,291.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.65,428.02c0.18-0.18,0.18-0.18,0.35-0.35c-10.52,12.27-18.06,23.67-21.91,33.66l0,0 C323.94,451.69,331.3,440.3,341.65,428.02z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.61,461.68c2.45-5.79,5.61-11.4,9.29-17.18C326.22,450.11,322.89,456.07,320.61,461.68L320.61,461.68z"
}), React.createElement("path", {
  className: "st1",
  d: "M334.99,436.79c-0.53,0.7-1.23,1.58-1.75,2.28C333.93,438.54,334.46,437.49,334.99,436.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.37,291.8c-0.7,0.35-1.23,0.7-1.93,1.23c10.34-6.14,19.64-11.75,27.35-16.3 c-4.73,2.63-9.47,5.61-14.03,8.24C525.91,287.25,522.4,289.52,518.37,291.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,461.51l0.35,0.18c2.45-5.79,5.61-11.4,9.29-17.18c1.23-1.75,2.1-3.51,3.33-5.26 c0.53-0.7,1.23-1.58,1.75-2.28c2.1-2.81,4.38-5.79,6.66-8.59C331.3,440.3,323.94,451.69,320.08,461.51z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.37,291.8c4.03-2.45,7.71-4.56,11.22-6.84C525.91,287.25,522.22,289.52,518.37,291.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M263.81,656.99l0.88,42.08c1.75,84.85,26.3,99.58,80.47,128.68c-2.28-3.51-4.56-7.36-6.49-11.22 c0,0,0-0.18-0.18-0.18c-1.23-2.45-2.45-4.91-3.51-7.54c-12.1-26.47-15.78-57.33-18.41-89.41v-1.23c-0.7-9.99-1.23-20.69-1.75-31.56 L263.81,656.99z"
}), React.createElement("path", {
  className: "st0",
  d: "M334.99,808.81c1.05,2.63,2.28,5.08,3.51,7.54C337.09,814.07,336.04,811.44,334.99,808.81z"
}), React.createElement("path", {
  className: "st0",
  d: "M345.51,828.27c-2.63-3.68-4.91-7.54-7.01-11.57c1.93,4.03,4.21,7.71,6.49,11.22 C345.33,827.92,345.33,828.1,345.51,828.27z"
}), React.createElement("path", {
  className: "st0",
  d: "M316.4,718.52l-0.35-30.86l-1.23-0.7C315.18,697.84,315.7,708.18,316.4,718.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M352.69,838.09c-62.06-33.66-91.87-45.76-93.62-139.03l-0.88-45.23l-2.98-1.75c-1.58-1.05-2.63-2.63-2.63-4.56 l-4.03-217.92l5.08,269.64c1.75,92.57,30.86,108.17,88.89,139.55c9.64,5.26,19.99,10.87,31.38,17.36c0.35,0.18,0.88,0.18,1.4,0.35 c-2.98-1.75-5.96-3.16-8.59-5.26C361.46,847.38,356.9,842.82,352.69,838.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M328.5,734.12c-0.35-3.16-0.53-6.31-0.88-9.64C327.97,727.64,328.32,730.97,328.5,734.12z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.52,686.61c0.35,11.22,1.05,22.09,1.75,32.43l-0.53-33.13L325.52,686.61z"
}), React.createElement("path", {
  className: "st1",
  d: "M340.07,793.21c7.19,21.39,17.53,38.04,32.78,49.44c1.58,1.23,3.51,2.1,5.26,3.16 C359.18,831.78,347.61,813.89,340.07,793.21z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.04,796.89c-7.54-21.56-11.75-47.69-14.2-78.02v0.18C324.12,746.4,327.27,773.4,336.04,796.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M381.09,854.39c0.18-0.18,0-0.35,0.18-0.53c-1.58-0.88-3.16-1.58-4.73-2.45l0,0 c-8.42-4.91-16.13-9.12-23.67-13.15c4.21,4.73,8.59,9.29,13.67,12.97c2.63,1.93,5.79,3.51,8.59,5.26c0.35,0.18,0.88,0.35,1.23,0.35 C378.29,856.85,379.87,855.79,381.09,854.39z"
}), React.createElement("path", {
  className: "st1",
  d: "M379.52,846.85c-0.53-0.35-1.05-0.88-1.58-1.23c-1.75-1.05-3.51-1.93-5.26-3.16 c-15.25-11.22-25.6-27.88-32.78-49.44c-6.49-18.23-9.64-38.22-11.57-59.08c-0.35-3.16-0.53-6.31-0.88-9.64 c-0.18-1.75-0.35-3.68-0.53-5.43v-0.18c-0.88-10.34-1.4-21.21-1.75-32.43l-2.81,1.58c0,0,0,0.18-0.18,0.18 c-0.35,0.18-0.7,0.18-1.23,0.35l0.35,30.5c2.28,30.33,6.66,56.45,14.2,78.02c7.89,21.21,20.16,39.97,40.5,54.35 c1.4,0.88,3.16,1.58,4.73,2.45C382.15,851.24,381.97,848.43,379.52,846.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47l2.63,199.86c-0.35,2.45-0.53,4.38-0.88,6.49l0.88-0.53L323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47L323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M326.75,679.6l-1.4,0.88c0,0.53,0,1.23,0,1.75l0,0c0,1.4,0.18,2.98,0.18,4.38l1.4-0.7L326.75,679.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.17,683.63c0,1.93-1.05,3.68-2.63,4.56l2.81-1.58c0-1.4-0.18-2.8-0.18-4.38 C325.17,682.41,325.17,683.63,325.17,683.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.69,673.82c-0.18,2.28-0.35,4.56-0.35,6.49l1.4-0.88v-6.31L325.69,673.82z"
}), React.createElement("polygon", {
  className: "st1",
  points: "323.59,467.47 323.94,467.47 323.94,467.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47v-0.7V467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M338.32,816.17c0,0,0,0.18,0.18,0.18C338.32,816.35,338.32,816.35,338.32,816.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M334.99,808.81c-10.34-24.02-15.6-54.52-18.41-90.46v1.23C319.03,751.66,322.89,782.34,334.99,808.81z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.33,699.06l-0.88-42.08l-5.43-3.16l1.05,45.41c1.75,93.44,31.73,105.54,93.62,139.03 c-2.81-3.33-5.43-6.66-7.89-10.34C290.98,798.64,266.09,783.74,264.33,699.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.04,796.89c-8.77-23.84-11.92-50.49-14.2-77.84v-0.18c-0.7-9.64-1.23-19.81-1.75-30.15 c-0.18,0-0.18,0-0.35,0c-0.88,0-1.75-0.18-2.63-0.7l-1.23-0.7l0.35,30.86c2.81,36.12,8.06,66.44,18.41,90.46 c1.05,2.45,2.28,5.08,3.51,7.54c0,0,0,0.18,0.18,0.18c2.1,4.03,4.56,7.89,7.01,11.57c-0.18-0.18-0.35-0.18-0.53-0.35 c2.45,3.68,5.08,7.19,7.89,10.34c7.36,4.03,15.25,8.24,23.67,13.15l0,0C357.08,839.67,344.28,821.43,336.04,796.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M321.84,718.87l-0.35-30.5c-0.35,0.18-0.88,0.35-1.23,0.35C320.61,699.24,321.14,709.58,321.84,718.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.04,796.89c8.59,24.37,21.21,42.78,40.5,54.35C355.85,837.04,343.75,818.28,336.04,796.89z"
}), React.createElement("path", {
  className: "st2",
  d: "M313.77,659.62c-0.35-21.21-0.53-43.65-0.53-67.32c0-0.35,0-0.7,0-1.05c0-36.64-0.18-74.33-1.4-115.36 c0-1.93,0.35-4.03,0.7-6.14l-34.89-20.16l-18.06-10.34l3.86,205.3l50.67,29.63C314.12,669.26,314.12,664.35,313.77,659.62z"
}), React.createElement("path", {
  className: "st2",
  d: "M313.77,659.62c-0.35-21.21-0.53-43.83-0.53-67.32C313.25,615.79,313.6,638.4,313.77,659.62z"
}), React.createElement("path", {
  className: "st2",
  d: "M312.55,469.75c-0.35,2.1-0.7,4.21-0.7,6.14C311.84,473.96,312.37,471.85,312.55,469.75L312.55,469.75z"
}), React.createElement("path", {
  className: "st2",
  d: "M313.77,659.62c0.18,4.91,0.18,9.64,0.35,14.55l0,0C314.12,669.26,314.12,664.35,313.77,659.62z"
}), React.createElement("path", {
  className: "st2",
  d: "M312.02,475.71c1.23,40.85,1.4,78.72,1.4,115.36c0,0.35,0,0.7,0,1.05c0-0.35,0-0.7,0-1.23 C313.25,554.43,313.07,516.73,312.02,475.71z"
}), React.createElement("path", {
  className: "st2",
  d: "M314.65,674.52c0.18-2.28,0.53-4.56,0.88-6.84l-2.81-197.76l-0.35-0.18c-0.35,2.1-0.7,4.21-0.7,6.14 c1.23,40.85,1.4,78.72,1.4,115.18c0,0.35,0,0.7,0,1.23c0.18,23.49,0.18,46.11,0.53,67.32c0.18,4.91,0.18,9.64,0.35,14.55 L314.65,674.52z"
}), React.createElement("path", {
  className: "st2",
  d: "M259.78,439.07l17.71,10.34L259.78,439.07z"
}), React.createElement("rect", {
  x: 261.53,
  y: 439.07,
  className: "st2",
  width: 0,
  height: 205.29
}), React.createElement("path", {
  className: "st2",
  d: "M315.7,666.45l-2.98-196.7l2.81,197.76C315.7,667.16,315.7,666.98,315.7,666.45z"
}), React.createElement("path", {
  className: "st2",
  d: "M259.78,439.07L259.78,439.07L259.78,439.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.65,683.98c0-0.18-0.18-0.18-0.18-0.35c0-1.05,0-2.28,0-3.33l-50.84-29.63l0.18,6.31l51.02,29.8 C314.65,685.91,314.65,684.86,314.65,683.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.65,683.98c0,0.88,0,1.75,0.18,2.8l1.23,0.7v-0.53C315.35,686.09,314.65,685.04,314.65,683.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.3,680.3c0,1.05,0,2.28,0,3.33c0,0.18,0.18,0.18,0.18,0.35C314.65,682.76,314.3,681.53,314.3,680.3 L314.3,680.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.65,683.98c0.18,1.05,0.7,2.1,1.4,2.98v-5.79l-1.58-0.88C314.3,681.53,314.65,682.76,314.65,683.98z"
}), React.createElement("path", {
  className: "st1",
  d: "M255.39,652.08l2.98,1.75l-0.18-6.31l0,0l-4.03-211.61l-2.81-1.58c-0.88-0.53-1.58-1.23-1.93-2.1 c-0.18-0.18-0.18-0.53-0.18-0.7c-0.18-0.53-0.53-1.23-0.53-1.93l0,0l4.21,217.92C252.76,649.45,253.99,651.03,255.39,652.08z"
}), React.createElement("path", {
  className: "st1",
  d: "M248.56,429.6L248.56,429.6c0,0.88,0.18,1.4,0.35,1.93C248.91,430.83,248.56,430.3,248.56,429.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M251.19,434.16c-0.88-0.53-1.4-1.23-1.93-2.1C249.61,432.93,250.48,433.63,251.19,434.16z"
}), React.createElement("path", {
  className: "st1",
  d: "M321.31,688.37L321.31,688.37c0.35,0,0.88,0,1.23-0.18c0,0,0-0.18,0.18-0.18h-0.18 C322.36,688.37,321.84,688.37,321.31,688.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47c-0.7,2.81-1.23,5.43-1.05,7.89c1.23,41.02,1.4,78.89,1.4,115.53c0,0.18,0,0.35,0,0.53 c0,14.2,0.18,27.88,0.18,41.2c0,0.53,0,1.23,0,1.75c0.18,11.22,0.35,21.74,0.53,32.26c0,2.63,0.18,5.08,0.18,7.71l0.7-0.35 c0.18-1.93,0.53-4.03,0.88-6.49L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.99,674.52L324.99,674.52c0-2.63,0-5.08-0.18-7.71C324.99,669.26,324.99,671.89,324.99,674.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.47,634.37c0-0.53,0-1.23,0-1.75C324.47,633.32,324.47,633.67,324.47,634.37z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47c0,0.18-0.18,0.18-0.18,0.35c-0.7,2.63-1.05,5.26-0.88,7.54 C322.54,473.08,322.89,470.27,323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.89,475.36c1.23,41.02,1.4,78.89,1.4,115.53c0,0.18,0,0.18,0,0.35c0-0.18,0-0.35,0-0.53 C324.12,554.43,323.94,516.38,322.89,475.36z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.17,682.23L325.17,682.23c0-0.53,0-1.23,0-1.75h-0.18C325.17,681.18,325.17,681.53,325.17,682.23z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.17,683.63c0,0,0-1.23,0-1.4c0-0.53,0-1.05,0-1.75l-3.86,2.28v5.79c0.35-0.18,0.88-0.18,1.23-0.35h0.18 C324.12,687.14,325.17,685.56,325.17,683.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.47,632.79c-0.18-13.32-0.18-27.17-0.18-41.2C324.12,605.62,324.12,619.29,324.47,632.79z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.99,666.8c-0.18-10.52-0.53-21.04-0.53-32.26C324.47,645.42,324.47,656.28,324.99,666.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.17,674.17c0,2.1,0.18,4.21,0.18,6.14h0.18c0-1.93,0.18-4.21,0.35-6.49L325.17,674.17z"
}), React.createElement("path", {
  className: "st1",
  d: "M324.99,674.52c0-2.45,0-5.26-0.18-7.71c-0.18-10.52-0.35-21.21-0.53-32.26c0-0.53,0-1.23,0-1.75 c-0.18-13.32-0.18-27-0.18-41.2c0-0.18,0-0.18,0-0.35c0-36.64-0.18-74.51-1.4-115.53c0-2.28,0.18-4.91,0.88-7.54 c0,0.18-0.18,0.53-0.35,0.7c-0.53,1.4-1.75,2.63-3.16,3.16c-0.53,0.18-1.23,0.35-1.75,0.35l2.81,195.48c0,0.18,0,0.35,0,0.53 l0.18,14.73l3.86-2.28C325.17,678.37,325.17,676.27,324.99,674.52L324.99,674.52z"
}), React.createElement("path", {
  className: "st1",
  d: "M249.43,432.06c-0.18-0.18-0.18-0.53-0.18-0.7C249.08,431.88,249.08,431.88,249.43,432.06z"
}), React.createElement("path", {
  className: "st1",
  d: "M253.99,429.25c0-0.18,0-0.18,0.18-0.35c0-1.4,0.35-2.98,0.7-4.56c-1.23-0.18-2.45,0-3.51,0.53 c-1.58,0.88-2.63,2.63-2.45,4.56c0,0.7,0.18,1.4,0.35,1.93c0,0.18,0,0.53,0.18,0.7c0.53,0.88,1.05,1.58,1.93,2.1l2.81,1.58 L253.99,429.25L253.99,429.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M255.39,424.34c-0.18,0-0.35-0.18-0.53-0.18c-0.35,1.58-0.53,3.16-0.7,4.56 C254.34,427.5,255.04,425.92,255.39,424.34z"
}), React.createElement("path", {
  className: "st1",
  d: "M323.94,467.47c0,0.18-0.18,0.35-0.18,0.35S323.59,467.64,323.94,467.47L323.94,467.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59v0.18V466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.94v5.26c0.53,0,1.23,0,1.75-0.35c1.58-0.53,2.81-1.75,3.16-3.16c0-0.18,0.18-0.53,0.35-0.7 c0-0.18,0.18-0.35,0.18-0.35v-0.88c-0.18-1.93-1.05-3.68-2.81-4.56l-0.53-0.35C319.73,463.26,319.03,464.84,318.16,466.94 C318.16,466.59,318.16,466.59,318.16,466.94z"
}), React.createElement("polygon", {
  className: "st1",
  points: "313.77,457.83 259.78,426.45 259.78,426.45  "
}), React.createElement("path", {
  className: "st1",
  d: "M253.99,429.25v0.35c0-0.18,0.18-0.53,0.18-0.7C253.99,429.08,253.99,429.25,253.99,429.25z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.35,458.7l-1.58-0.88l-54.35-31.38l0,0l-2.81-1.75c-0.53-0.18-0.88-0.18-1.4-0.35 c-0.35,1.4-0.88,2.98-1.23,4.38c0,0.18-0.18,0.53-0.18,0.7l59.78,34.54C314.12,462.21,314.65,460.46,315.35,458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.7,458.7L315.7,458.7c-0.7,1.75-1.4,3.51-1.93,5.26l0,0C314.12,462.21,314.82,460.81,315.7,458.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59c0.35-1.75,1.23-3.51,1.93-5.26l-4.56-2.63c-0.7,1.75-1.23,3.51-1.75,5.26 L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59c0.35-1.58,1.23-3.33,1.93-5.08l0,0C319.56,463.09,318.68,465.19,318.16,466.59L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59c0.53-1.58,1.58-3.33,2.28-4.91l0,0C319.73,463.26,319.03,464.84,318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,461.51c-0.7,1.75-1.4,3.51-1.93,5.08c0.53-1.58,1.58-3.33,2.28-4.91L320.08,461.51z"
}), React.createElement("polygon", {
  className: "st1",
  points: "263.63,650.68 258.2,647.52 258.37,653.83 263.81,656.99  "
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,689.07c-0.88,0-1.93-0.18-2.81-0.7c0.7,0.53,1.58,0.7,2.63,0.7 C319.73,689.07,320.08,688.89,320.08,689.07C320.08,688.89,320.08,688.89,320.08,689.07C320.08,688.89,320.08,689.07,320.08,689.07 z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.88,687.67l1.23,0.7c-0.53-0.35-0.88-0.88-1.23-1.23V687.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,688.89L320.08,688.89c0.35,0,0.88-0.18,1.23-0.35l0,0C320.79,688.72,320.61,688.89,320.08,688.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.73,682.41v0.35c0-0.18,0-0.53,0-0.7C319.73,681.88,319.73,682.23,319.73,682.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,688.89c0-1.75-0.18-3.51-0.18-5.26l-4.03-2.28v5.79c0.35,0.53,0.7,0.88,1.23,1.23 C317.98,688.72,319.03,689.07,320.08,688.89C320.08,689.07,320.08,688.89,320.08,688.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.73,682.58l0.18,1.05c0-1.05,0-2.28-0.18-3.33c0,0.53,0,1.05,0,1.58 C319.73,682.23,319.73,682.41,319.73,682.58z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,683.63L320.08,683.63c0,1.75,0,3.51,0.18,5.26c0.53,0,0.88-0.18,1.23-0.35v-5.79L320.08,683.63 L320.08,683.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.73,680.3c0,1.05,0,2.28,0.18,3.33l1.4-0.7l-0.18-14.73C320.26,672.41,320.08,676.27,319.73,680.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.12,673.99l-50.67-29.63l0.18,6.31l50.84,29.63C314.3,678.2,314.12,676.1,314.12,673.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.12,673.99L314.12,673.99c0,2.1,0,4.21,0.18,6.31l0,0C314.3,678.2,314.12,676.1,314.12,673.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M314.65,674.52l-0.53-0.35c0,2.1,0.18,4.21,0.18,6.31l1.58,0.88l-0.18-13.68 C315.35,669.78,314.82,672.06,314.65,674.52z"
}), React.createElement("rect", {
  x: 256.09,
  y: 435.74,
  className: "st1",
  width: 0,
  height: 211.61
}), React.createElement("path", {
  className: "st1",
  d: "M321.14,668.21c0-0.18,0-0.35,0-0.53l-2.81-195.48l0,0L321.14,668.21z"
}), React.createElement("polygon", {
  className: "st1",
  points: "253.99,429.6 253.99,435.74 253.99,435.74  "
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59L318.16,466.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.59L318.16,466.59L318.16,466.59z"
}), React.createElement("polygon", {
  className: "st1",
  points: "318.16,466.94 318.51,472.03 318.51,472.03  "
}), React.createElement("polygon", {
  className: "st1",
  points: "263.28,644.19 263.28,644.19 259.78,439.07 253.99,435.74 258.2,647.52 263.63,650.68  "
}), React.createElement("polygon", {
  className: "st1",
  points: "277.48,449.41 312.55,469.75 312.55,469.57  "
}), React.createElement("polygon", {
  className: "st1",
  points: "312.55,469.57 312.55,469.57 312.55,469.75 312.55,469.75  "
}), React.createElement("path", {
  className: "st1",
  d: "M319.73,682.41c0-0.18,0-0.18,0-0.35c-1.58-44.71-0.88-96.42-1.58-153.75c0-2.8,0-5.43-0.18-8.24 c0-5.79-0.18-11.4-0.35-17.36c-0.18-8.94-0.35-17.88-0.7-27c0-1.05,0.35-2.45,0.35-3.68c-0.7-0.18-1.4-0.18-1.93-0.53l-2.81-1.93 l0,0l0.35,0.18l2.98,196.7c0,0.35,0,0.7-0.18,1.05l0.18,13.68l4.03,2.28c0-0.35,0-0.7,0-1.05L319.73,682.41L319.73,682.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,519.71c0-5.79-0.18-11.4-0.35-17.36C317.98,508.49,317.98,514.1,318.16,519.71z"
}), React.createElement("path", {
  className: "st1",
  d: "M319.73,681.71c0-0.53,0-1.05,0-1.58c-1.58-44.36-0.88-95.55-1.58-152.17 C319.03,585.28,318.16,637,319.73,681.71z"
}), React.createElement("path", {
  className: "st1",
  d: "M320.08,683.63l-0.18-1.05C319.73,682.76,319.73,683.28,320.08,683.63L320.08,683.63L320.08,683.63z"
}), React.createElement("path", {
  className: "st1",
  d: "M317.63,471.85c-0.18,1.23-0.53,2.45-0.35,3.68C317.28,474.48,317.46,473.08,317.63,471.85L317.63,471.85z"
}), React.createElement("path", {
  className: "st1",
  d: "M317.98,502.53c-0.18-8.94-0.35-17.88-0.7-27C317.46,484.65,317.63,493.77,317.98,502.53z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,528.13c0-2.8,0-5.43-0.18-8.24C318.16,522.52,318.16,525.5,318.16,528.13z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,472.03c-0.18,0-0.35-0.18-0.7-0.18c-0.18,1.23-0.53,2.45-0.35,3.68c0.35,9.12,0.53,18.06,0.7,27 c0.18,5.79,0.18,11.57,0.35,17.36c0,2.8,0.18,5.61,0.18,8.24c0.7,56.63,0,107.64,1.58,152.17c0-3.86,0.53-7.89,1.23-12.1 L318.16,472.03L318.16,472.03z"
}), React.createElement("path", {
  className: "st1",
  d: "M277.48,449.41l35.06,19.99c0.18-1.05,0.18-1.93,0.35-2.98c0.18-0.88,0.53-1.58,0.7-2.45l-59.78-34.54 l0.18,6.31l5.61,3.16l0,0L277.48,449.41z"
}), React.createElement("path", {
  className: "st1",
  d: "M313.07,466.42c-0.18,1.05-0.18,1.93-0.35,2.98l0,0C312.72,468.7,312.55,467.47,313.07,466.42z"
}), React.createElement("path", {
  className: "st1",
  d: "M313.6,464.14c-0.18,0.88-0.53,1.75-0.7,2.45C313.07,465.89,313.6,464.84,313.6,464.14L313.6,464.14z"
}), React.createElement("path", {
  className: "st1",
  d: "M315.7,471.33c0.53,0.35,1.23,0.53,1.93,0.53c0.18-1.75,0.18-3.33,0.7-5.08l0,0l-4.56-2.63 c-0.18,0.88-0.7,1.58-0.88,2.45c-0.18,1.05-0.18,2.1-0.35,2.98L315.7,471.33z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,466.94L318.16,466.94c-0.53,1.75-0.53,3.51-0.7,5.08l0,0C317.63,470.27,317.98,468.7,318.16,466.94z"
}), React.createElement("path", {
  className: "st1",
  d: "M318.16,472.03L318.16,472.03v-5.26c-0.53,1.75-0.53,3.51-0.7,5.08C317.98,471.85,317.98,472.03,318.16,472.03 z"
}));

var SvgShieldIcon = function SvgShieldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShieldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Shield_Icon.a4303ab9.svg";
export { ForwardRef as ReactComponent };